var $43ec837f3c00fd8c$exports = {};
$43ec837f3c00fd8c$exports = {
    "replaceMessage": `Pudota korvaava tiedosto`
};


export {$43ec837f3c00fd8c$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
